import { notesAndImageValidationValues } from '../constants'

export const isValidationActive = validation => {
  return [notesAndImageValidationValues.required, notesAndImageValidationValues.optional].includes(validation)
}
